import logoSprite from '@/assets/LOGO_BrSE.png'
import { useStore } from '@/store/useStore'

interface LogoBrSEProps {
  className?: string
}

export default function LogoBrSE({ className = '' }: LogoBrSEProps) {
  const theme = useStore((s) => s.theme)
  const isDark = theme === 'dark'

  return (
    <span
      // `shrink-0` at every breakpoint: this element crops the sprite by
      // clipping height via `overflow-hidden`, so shrinking its width in a
      // tight flex row (e.g. the auth header) doesn't scale the logo down —
      // it truncates it mid-glyph instead, and the next sibling (whose own
      // `overflow-visible` box also gets shrunk) bleeds back over the
      // truncated gap, visually overlapping it. A prior fix scoped this
      // guard to mobile only (`sm:shrink` reverted it at 640px+), but the
      // same clip-and-overlap reproduces at desktop widths too whenever the
      // header row doesn't have enough space — the header row wraps instead
      // of shrinking at every breakpoint now (see Login/Register `index.tsx`).
      className={`inline-flex max-w-full shrink-0 overflow-hidden ${className}`}
      role="img"
      aria-label="BrSE.ai"
    >
      <img
        src={logoSprite}
        alt=""
        aria-hidden
        className={`block h-[200%] w-auto max-w-none ${isDark ? '-translate-y-1/2' : 'translate-y-[1px]'}`}
      />
    </span>
  )
}
